import { render, staticRenderFns } from "./UserCustomFields.vue?vue&type=template&id=314454ea&scoped=true&lang=pug"
import script from "./UserCustomFields.vue?vue&type=script&lang=js"
export * from "./UserCustomFields.vue?vue&type=script&lang=js"
import style0 from "./UserCustomFields.vue?vue&type=style&index=0&id=314454ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314454ea",
  null
  
)

export default component.exports